import GroupOrderGuest from './GroupOrderGuest'

export default GroupOrderGuest
